import React, { Component } from 'react';
import { Col, Row, Container } from 'reactstrap';
import getConfig from 'next/config';
import SelectByPlatform from '../../../../workplace/common/selectByPlatform';
import {Waypoint} from "react-waypoint";

const config = getConfig().publicRuntimeConfig;

export default class VideoPanel extends Component {
	constructor(props) {
		super(props);
		this.state = { loadVideo: false };
	}

	_handleWaypointEnter = () => {
		this.setState({
			loadVideo: true
		});
	};

	render() {
		return (
			<Container className="panel-padding">
				<Waypoint onEnter={this._handleWaypointEnter} bottomOffset={-200} />
				{(this.state.loadVideo)?
				<SelectByPlatform>
					<React.Fragment name="www">
						<Row className="align-items-stretch video-panel-row">
							<Col xs="12" md="6" lg="6">
								<div className="video-responsive">
									<iframe width="853" height="480" src={this.props.videoUrl} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
								</div>
							</Col>
							<Col xs="12" md="6" lg="6" className="home-page-why-giveindia-panel">
								<div className="video-panel-right-side-panel">
									<div>
										<h3>GiveIndia is India's most trusted donations platform</h3>
										<p>Sign up for monthly donations on GiveIndia and create a long-lasting impact on the lives of the poor in India</p>
									</div>
									<div>
										<h3>Why GiveIndia?</h3>
										<div>
											<Row className="d-flex why-giveindia-panel-for-mobile">
												<Col sm="6" xs="6" md="6" lg="6" className="p-0" style={{ display: 'flex', alignItems: 'center' }}>
													<img className="program-page-bitmap" src={`${config.cdnUrl}/static/icons/gi_TRUST.svg`} alt="convenient setup" />
													<p className="why-monthly-giving-box-text" >High trust</p>
												</Col>
												<Col sm="6" xs="6" md="6" lg="6" className="" style={{ display: 'flex', alignItems: 'center' }}>
													<img className="program-page-bitmap" src={`${config.cdnUrl}/static/icons/gi_CONVENIENCE.svg`} alt="Long-term impact" />
													<p className="why-monthly-giving-box-text"  >Convenience</p>
												</Col>
											</Row>
											<Row className="why-giveindia-panel-for-mobile" style={{ paddingBottom: '1rem', paddingTop: '1rem' }}>
												<Col sm="6" xs="6" md="6" lg="6" className="p-0" style={{ display: 'flex', alignItems: 'center' }}>
													<img className="program-page-bitmap" style={{ whiteSpace: 'nowrap' }} src={`${config.cdnUrl}/static/icons/gi_TAX.svg`} alt="Deep Engagement" />
													<p className="why-monthly-giving-box-text" >Tax exemption</p>
												</Col>
												<Col sm="6" xs="6" md="6" lg="6" style={{ display: 'flex', alignItems: 'center' }}>
													<img className="program-page-bitmap" src={`${config.cdnUrl}/static/icons/gi_REPORT.svg`} alt="High commitment" />
													<p className="why-monthly-giving-box-text"  >Regular report</p>
												</Col>
											</Row>
										</div>
									</div>
								</div>
							</Col>
						</Row>

						<style jsx global>
							{`

							.video-panel-row {
							    border: 1px solid rgba(0,0,0,0.1);
							    }

								.video-responsive{
									overflow:hidden;
									padding-bottom:56.25%;
									position:relative;
									height:0;
								}
								.video-responsive iframe{
									left:0;
									top:0;
									height:100%;
									width:100%;
									position:absolute;
								}
								.why-monthly-giving-box-text{
									display : inline;
									padding-left: 10px;
									color: #444444;
									white-space: nowrap;
									margin-bottom: 0px;
								}
									.home-page-why-giveindia-panel{
										padding: 1rem 2rem 1rem 2rem;
										border: none;
										border-radius: 4px;
										box-shadow: none;
									}
									@media (max-width: 768px) {
										.home-page-why-giveindia-panel{
											padding: 16px 15px 0 15px;
											border: none;
										border-radius: none;
										box-shadow:none;
									}
								}
								@media (max-width: 768px) {
									.why-giveindia-panel-for-mobile{

									}
									}

	     				`}
						</style>
					</React.Fragment>
					<React.Fragment name="wg">
					</React.Fragment>
				</SelectByPlatform> : null}
			</Container>


		);
	}
}
